
    import { localeIncludes, localeStart } from '@/helpers/node_gm_common'
    import { defineComponent, PropType } from 'vue'

    export interface InputTextSuggestion {
        name: string
        value: string
    }

    export default defineComponent({
        props: {
            placeholder: String,
            label: String,
            value: String,
            suggestions: Object as PropType<InputTextSuggestion[]>,
        },
        components: {

        },
        data() {
            return {
                id: 'input-text' + +new Date()
            }
        },
        computed: {
            suggestionsFiltered() {
                if (!this.suggestions) return []
                const byStart = this.suggestions.filter((el) => this.value ? localeStart(el.name, this.value) : true)
                const byInclude = this.suggestions.filter((el) => this.value ? localeIncludes(el.name, this.value) : true)
                return [...byStart, ...byInclude]
            },
        },
        methods: {
            suggest(suggestion: InputTextSuggestion) {
                this.$emit('update:value', suggestion.value)
                this.$emit('suggest', suggestion)
            },
        },

        mounted () {
            this.$emit('mounted', this.$refs.input)
        },
    })

    